__webpack_require__.p = "https://static.fotor.com/app/minitools/ai-action-figure/";